import { render, staticRenderFns } from "./CatalogFiltersWidgetSlider.vue?vue&type=template&id=b4f7bf40&"
import script from "./CatalogFiltersWidgetSlider.js?vue&type=script&lang=js&"
export * from "./CatalogFiltersWidgetSlider.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CatalogFiltersWidgetSlider.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fcatalog%2FCatalogFiltersWidgetSlider%2FCatalogFiltersWidgetSlider.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports